import { Component } from '@angular/core';

@Component({
    selector: 'app-consult-note-history-item-body',
    template: '<div><ng-content /></div>'
})
export class ConsultNoteHistoryItemBodyComponent {}
